module.exports = __webpack_public_path__ + "static/img/2.8d0053d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/2.png
// module id = 1iH2
// module chunks = 0